import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import Layout, { PageHeader } from "../components/Layout";
import SEO from "../components/SEO";
import { Stagger, StaggerItem, Reveal } from "../components/motion";
import { FACTORY_FLOW } from "../data/site";
import { IMAGES } from "../data/images";

export default function HowWeWork() {
  return (
    <Layout>
      <SEO title="How We Work" description="The Eazymuv engagement model: start inside the factory, stabilise execution, instrument with Eazymuv OS, extend across logistics, then land and expand." />
      <PageHeader dark eyebrow="The Engagement" title={<>Start inside the factory. <span className="text-ez-yellow">Then expand.</span></>} subtitle="A de-risked, land-and-expand model that proves execution in one facility before scaling across the network." image={IMAGES.coldWarehouse} imageAlt="Managed cold storage facility" />
      <section className="bg-ez-bg">
        <div className="max-w-[1600px] mx-auto px-5 md:px-8 py-20 md:py-28">
          <Stagger className="border border-ez-text divide-y divide-ez-text">
            {FACTORY_FLOW.map((s) => (
              <StaggerItem key={s.n}>
                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 p-8 md:p-10 group hover:bg-ez-yellow transition-colors">
                  <div className="md:col-span-2 font-display text-6xl tracking-tighter text-ez-text/20 group-hover:text-ez-text">{s.n}</div>
                  <div className="md:col-span-4 font-display text-2xl uppercase tracking-tight leading-tight">{s.t}</div>
                  <div className="md:col-span-6 text-ez-text/70 leading-relaxed group-hover:text-ez-text/80">{s.d}</div>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
          <Reveal delay={0.1}>
            <Link to="/contact" data-testid="howwework-cta" className="mt-10 inline-flex items-center gap-2 bg-ez-text text-ez-bg px-7 py-4 font-semibold hover:bg-ez-yellow hover:text-ez-text transition-colors">
              Start the Conversation <ArrowRight size={18} weight="bold" />
            </Link>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}
